import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/change-password.png'
import _imports_1 from '@/assets/img/harapan-jaya.png'


const _hoisted_1 = { class: "password background-grey-lighten-5 w-100 h-100 pb-16 relative" }
const _hoisted_2 = { class: "flex card bg-white items-center" }
const _hoisted_3 = { class: "form pb-0 lg:w-1/2 md:w-full sm:w-full flex flex-col justify-between" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-field mb-6" }
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "p-field mb-6" }
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = {
  key: 1,
  class: "mx-auto font-bold text-white"
}

import {
  ref,
  onMounted,
  getCurrentInstance,
  reactive
} from 'vue'
import Button from 'primevue/button'
import Card from 'primevue/card'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
// import InputText from 'primevue/inputtext'
import { useRouter, useRoute } from 'vue-router'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  setup(__props) {

const loading = ref(false)
const router = useRouter()

const schema = Yup.object().shape({
  password: Yup.string().required('Password harus diisi'),
  confirmPassword: Yup.string().oneOf([Yup.ref('password')], 'Password tidak sama')
})

const initialValues = {
  password: '',
  confirmPassword: ''
}

const onSubmit = (values: any) => {
  console.log('masukk submit', values)
  loading.value = true
}


return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "lg:hidden md:block sm:block xs:block px-10 py-16 top-info" }, [
      _createElementVNode("h4", { class: "text-white font-bold" }, "Ubah Password"),
      _createElementVNode("p", { class: "text-lg text-white" }, "Silahkan melakukan ubah password untuk akun: nofrianfrisnanda@gmail.com")
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _cache[4] || (_cache[4] = _createStaticVNode("<div id=\"change-password\" class=\"image-left lg:w-1/2 lg:block md:hidden sm:hidden relative\"><div class=\"flex flex-col justify-between info px-6 py-6\"><div><h4 class=\"text-white\">Ubah Password</h4><p class=\"text-white\">Silahkan melakukan ubah password untuk akun: nofrianfrisnanda@gmail.com</p></div><div class=\"image-bottom\"><img src=\"" + _imports_0 + "\" class=\"w-90 mx-auto\" alt=\"logo\"></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            src: _imports_1,
            class: "h-10 mx-auto",
            alt: "logo"
          }, null, -1)),
          _createVNode(_unref(Form), {
            onSubmit: onSubmit,
            "validation-schema": _unref(schema),
            "initial-values": initialValues,
            class: "p-16 w-full"
          }, {
            default: _withCtx(({ errors, setFieldValue, values }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[0] || (_cache[0] = _createElementVNode("label", { for: "password" }, "Password Baru", -1)),
                  _createVNode(_unref(Field), {
                    name: "password",
                    onChange: _ctx.handleChange,
                    onBlur: _ctx.handleBlur
                  }, {
                    default: _withCtx(({ handleChange, handleBlur }) => [
                      _createVNode(_unref(Password), {
                        autofocus: "",
                        feedback: false,
                        placeholder: "********",
                        modelValue: values.password,
                        "onUpdate:modelValue": ($event: any) => ((values.password) = $event),
                        toggleMask: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["onChange", "onBlur"]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(errors.password), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[1] || (_cache[1] = _createElementVNode("label", { for: "confirmPassword" }, "Ulangi Password Baru", -1)),
                  _createVNode(_unref(Field), {
                    name: "confirmPassword",
                    onChange: _ctx.handleChange,
                    onBlur: _ctx.handleBlur
                  }, {
                    default: _withCtx(({ handleChange, handleBlur }) => [
                      _createVNode(_unref(Password), {
                        autofocus: "",
                        feedback: false,
                        placeholder: "********",
                        modelValue: values.confirmPassword,
                        "onUpdate:modelValue": ($event: any) => ((values.confirmPassword) = $event),
                        toggleMask: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["onChange", "onBlur"]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(errors.confirmPassword), 1)
                ])
              ]),
              _createVNode(_unref(Button), {
                class: "btn-primary",
                id: "submit-password",
                disabled: loading.value,
                type: "submit"
              }, {
                default: _withCtx(() => [
                  (loading.value)
                    ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                        key: 0,
                        strokeWidth: "8",
                        fill: "white"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, "Ubah Password"))
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-center color-blue-grey font-semibold text-xs" }, _toDisplayString('Version 1.0.0'), -1))
      ])
    ])
  ]))
}
}

})